// 用户取，选择方法
<template>
  <div class="selectWay fetchSelectWay">
    <!-- 流程 -->
    <userFetchFlow :index="1"></userFetchFlow>

    <div class="way-list clearfix">
      <div class="flex">
        <div class="list">
          <p class="title">方法1：请刷员工卡</p>
          <div class="detail clearfix">
            <div class="left-bracket"></div>
            <p class="img card"><img src="../../../../static/images/icon4.png" alt=""></p>
            <div class="right-bracket"></div>
          </div>
        </div>

        <div class="list">
          <p class="title">方法2：打开微信扫二维码</p>
          <div class="detail clearfix">
            <div class="left-bracket"></div>
            <div class="img code">
              <span
                class="text"
                v-show="QRurl === ''">二维码获取中...</span>
              <img
                :src="QRurl"
                v-show="QRurl !== ''" />
            </div>
            <div class="right-bracket"></div>
          </div>
        </div>
      </div>

      <div
        class="expressFetch"
        @click="changeWrapper">取件码取件</div>
      <div
        class="expressFetch-wrapper"
        v-show="wapperStatus">
        <div class="detail"
          :style="{ bottom: detailBottom}">
          <p class="title">
            取件码取件
            <span
              class="close"
              @click="changeWrapper"></span>
          </p>
          <el-form class="input-box">
            <el-input
              type="number"
              placeholder="请输入手机号后四位"
              v-model="phone_no"
              oninput="if (this.value.length > 4) {this.value = this.value.slice(0, 4); }"
              clearable>
            </el-input>
            <el-input
              class="open_password"
              type="number"
              placeholder="请输入六位取件码"
              v-model="open_password"
              oninput="if (this.value.length > 6) {this.value = this.value.slice(0, 6); }"
              clearable>
            </el-input>
            <el-button
              type="primary"
              class="btn-fetch"
              @click="fetchByOpenPassword()">取件</el-button>
          </el-form>
        </div>
      </div>
    </div>

    
    <!-- mqtt -->
    <mqttws ref="mqttws" @getMessage="getMessage"></mqttws> 
  </div>
</template>

<script>
import mqttws from '../../../assets/mqttws2'
import userFetchFlow from './userFetchFlow'
import { cabinetApi } from "../../../../static/turnoverCabinet/js/api.js"
import { showLoading, hideLoading, showToast, storage, showSuccess } from '../../../../static/turnoverCabinet/js/utility'

let timeout
export default {
  name: 'fetchSelectWay',
  components: {
    userFetchFlow,
    mqttws
  },
  data () {
    return {
      QRurl: '',
      phone_no: '',
      open_password: '',
      wapperStatus: false,
      authID: '',
      authPhone: '',
      detailBottom: 2.9 + 'rem'
    }
  },
  created () {
    this.getQRCode()
    // this.getFetchLoginInfo()
  },
  mounted () {
    // 处理
    let clientHeight = document.documentElement.clientHeight
    let newHeight
    // let detailWrapper = document.getElementsByClassName('expressFetch-wrapper')[0].getElementsByClassName('detail')[0]
    let vm = this
    window.onresize = function () {
      newHeight = document.documentElement.clientHeight
      // div距离底部高度,即键盘的高度
      let value = clientHeight - newHeight
      // alert(value)
      if (value > 0) {
        // 键盘遮挡住div
        // vm.detailBottom = vm.detailBottom - value
        vm.detailBottom = 0
        // alert('bottom', vm.detailBottom)
      } else {
        vm.detailBottom = 2.9 + 'rem'
      }
    }
  },
  // 页面销毁后
  destroyed () {
    // 停止轮询
    clearTimeout(timeout)
  },
  methods: {
    // 获取mqtt信息
    getMessage(res){
      console.log('mqtt返回信息',res)
      let vm = this
      // type信息类型：identityCheck为身份认证， Exp为扫描快递单号
      if (res.type === 'identityCheck') {
        if (res.meta.code === 200) {
          console.log('验证身份成功', res)
          let user_type = res.data.user_type
          // 若是快递员，限制没有权限
          if (user_type == 'courier') {
            showToast('快递员没有取件权限')
            return
          } else {
            showSuccess('验证身份成功')
            // 获取保存apitoken
            vm.$store.state.apitoken = res.data.apitoken
            // 确认取件参数 --- 取件方式
            this.$store.state.fetchData.fetch_way = res.data.way
            vm.getBoxList()
          }
        } else {
          showToast(res.meta.message)
        }
      }
    },
    // 获取用户的箱格信息
    async getBoxList(){
      let vm = this
      let data = {
        device_no_id: storage.localGetItem('device_no_id')
      }

      showLoading('获取箱格信息中')
      let res = await cabinetApi.getBoxList(data)
      hideLoading()
      console.log('获取箱格信息', data)
      if (res.meta.code === 200) {
          // if (!res.data.box_list) {
          //   showToast('请刷正确的员工卡')
          //   return
          // }
          let boxList = [...res.data]
          for (let i in boxList) {
            // showStatus表示箱格状态。false为未打开，true为已打开。
            this.$set(boxList[i], 'showStatus', false)
          }
          let  path = boxList.length > 1 ? '/turnoverCabinet/openBoxList' : '/turnoverCabinet/openBoxOne'
          this.$router.push({
            // 你要跳转的地址
            path: path,
            query: {boxList: JSON.stringify(boxList)}
          })
      } else {
        showToast(res.meta.message)
      }
    },
    // 获取小程序码
    async getQRCode () {
      let vm = this
      // zy表示周转柜身份验证
      let data = {
        mode: 'getUnlimited',
	      data: {
          page: 'pages/login/login',
    	    scene: vm.$store.state.company_ic + 'zy' + storage.localGetItem('device_no_id')
        },
        type: 'zy',
        device_no_id: storage.localGetItem('device_no_id')
      }

      let res = await cabinetApi.getQRCode(data)
      if (res.meta.code === 200) {
        this.QRurl = res.data.image_url
        console.log('res二维码生获取成功', res)
      } else {
        showToast('二维码获取失败')
        console.log('二维码获取失败', res)
      }
    },
    // 显示或隐藏选择取件框---选择手机后四位+取件码取件
    changeWrapper () {
      this.wapperStatus = !(this.wapperStatus)
    },
    // 取件码取件
    async fetchByOpenPassword () {
      let vm = this
      let data = {
        open_password: this.open_password,
        phone_no: this.phone_no,
        device_no_id: storage.localGetItem('device_no_id')
      }

      let msg = data.phone_no === '' || data.phone_no.length !== 4 ? '请输入手机号后四位' :
                data.open_password === '' ? '请输入取件码' : 
                data.open_password.length !== 6 ? '请输入正确的6位取件码' : ''
      if (msg !== '') {
        showToast(msg)
        return
      }

      showLoading('正在打开箱格')
      let res = await cabinetApi.fetchByOpenPassword(data)
      hideLoading()
      console.log('res', res)
        this.$router.push({
          // 你要跳转的地址
          path: '/turnoverCabinet/openBoxOne',
          query: {passwordFetch: JSON.stringify(res)}
        })
    }
  },
  watch: {
  }
}
</script>

<style scoped>
.expressFetch{
  float: left;
  width: 100%;
  color: #4babfe;
  text-align: center;
  font-size: 0.5rem;
  margin-top: 0.7rem;
  text-decoration: underline;
  position: relative;
  z-index: 10;
}

.expressFetch-wrapper{
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.4);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
}

.expressFetch-wrapper .detail{
  width: 5.5rem;
  height: 5rem;
  margin: 0 auto;
  border-radius: 0.1rem;
  background-color: #ffffff;
  position: absolute;
  left: 0 ;
  right: 0;
  /* bottom: 2.9rem; */
  z-index: 15;
}

.expressFetch-wrapper .detail .title{
  line-height: 0.88rem;
  color: #ffffff;
  font-size: 0.34rem;
  text-align: center;
  background-color: #0d508f;
  border-top-left-radius: 0.1rem;
  border-top-right-radius: 0.1rem;
  position: relative;
}

.expressFetch-wrapper .detail .close{
  display: block;
  width: 0.5rem;
  height: 0.5rem;
  background: url(../../../../static/turnoverCabinet/images/icon/close-white.png) center no-repeat;
  background-size: 100%;
  position: absolute;
  right: 0.15rem;
  top: 0;
  bottom: 0;
  margin: auto;
}

.expressFetch-wrapper .detail .input-box{
  padding: 0.7rem 0.31rem 0;
  margin: 0 0.27rem;
  position: relative;
  z-index: 99;
}

.expressFetch-wrapper .detail .input-box .el-input{
  width: 100%;
  display: block;
  margin-bottom: 0.16rem;
}

.expressFetch-wrapper .detail .btn-fetch{
  display: block;
  width: 1.6rem;
  height: 0.7rem;
  line-height: 0.7rem;
  padding: 0;
  margin: 0.25rem auto 0;
  font-size: 0.28rem;
  position: relative;
  z-index: 99;
}
.selectWay{
  width: 100%;
}

.selectWay .way-list{
  width: 15.27rem;
  margin: 0.8rem auto 0;
}

.selectWay .way-list .flex{
  display: flex;
  justify-content: center;
}

.selectWay .way-list .list{
  /* width: 6.14rem; */
  width: 6.14rem;
  text-align: center;
}

.selectWay .way-list .list:first-child{
  margin-right: 1.47rem;
}

.selectWay .way-list .list .title{
  font-size: 0.45rem;
  font-weight: bold;
  line-height: 0.5rem;
  margin-bottom: 0.4rem;
}

.selectWay .way-list .list .detail{
  width: 100%;
  padding: 0 0.5rem;
  height: 3.85rem;
}

.selectWay .way-list .list .detail .left-bracket,
.selectWay .way-list .list .detail .right-bracket{
  float: left;
  width: 0.54rem;
  height: inherit;
  border: 0.04rem solid #ffffff;
}

.selectWay .way-list .list .detail .left-bracket{
  border-right: none;
}

.selectWay .way-list .list .detail .right-bracket{
  border-left: none;
}

.selectWay .way-list .list .detail .img{
  float: left;
  width: 2.52rem;
  height: 2.52rem;
  line-height: 2.52rem;
  margin: 0.66rem 0.77rem 0;
  font-size: 0.34rem;
  background-color: #fff;
}

.selectWay .way-list .list .detail .card img{
  width: 100%;
}

.selectWay .way-list .list .detail .code img{
  display: block;
  width: 2.52rem;
  height: 2.52rem;
  position: relative;
  z-index: 9;
}
</style>



// WEBPACK FOOTER //
// src/components/turnoverCabinet/userFetch/fetchSelectWay.vue